export default __webpack_public_path__ + "static/media/imagen03.e45ec392.svg";